import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'

const productInvestmentsFields: FieldInterface[] = [
  {
    key: 'srri',
    originKey: 'srri',
    type: FIELD_TYPES.integer,
  },
  {
    key: 'name',
    originKey: 'name',
    type: FIELD_TYPES.string,
  },
  {
    key: 'isin',
    originKey: 'isin',
    type: FIELD_TYPES.string,
  },
  {
    key: 'data',
    originKey: 'data',
    type: FIELD_TYPES.object,
    enumType: 'ProductInvestmentsData',
    enumTypePath:
      'src/services/mappings/productInvestments/productInvestments.utils',
  },
]

const productInvestmentsRelations: RelationInterface[] = []

export { productInvestmentsFields, productInvestmentsRelations }
